import { useParams } from 'react-router-dom';

import { ROUTE } from 'src/constants/routes';
import { IntersectedEmptyObject } from 'src/constants/types';

export type ExtractRouteParams<T extends string> =
  // Split into tokens by slashes
  T extends `${infer BeforeSlash}/${infer AfterSlash}`
    ? ExtractRouteParams<BeforeSlash> & ExtractRouteParams<AfterSlash>
    : // Handle optional parameters
    T extends `:${infer Param}?`
    ? Record<Param, string | undefined>
    : // Handle required parameters
    T extends `:${infer Param}`
    ? Record<Param, string>
    : // Handle non-parameters
      IntersectedEmptyObject;

export const useRouterParams = <
  TRoute extends keyof typeof ROUTE = 'PROJECT'
>() => useParams<ExtractRouteParams<(typeof ROUTE)[TRoute]>>();
